<template>
    <cs-accordion
        :key="label"
        :label="label"
        :hasBorder="true"
        :trackingData="getTrackingData()"
        class="text-text-l-desktop"
        >{{ text }}</cs-accordion
    >
</template>

<script lang="ts" src="./HydratedStormLevelPanel.ts" />
